import Translate from '../../../modules/util/Translate'
import { LocaleMessages } from 'vue-i18n'

// コンポーネントの翻訳ファイル
import DownloadMessages from '../../../components/Membership/Download/language'
import ChangeMembership from '../../../components/Membership/ChangeMembership/language'
import Mypage from '../../../components/Membership/Mypage/language'
import Register from '../../../components/Membership/Register/language'
import Login from '../../../components/Membership/Login/language'
import cardLanguage from '../../../components/Card/language'

const MemberShip: LocaleMessages = {
  en: {
    /** ユーザ項目 */
    User: {
      email: 'Email Address',
      password: 'Password',
      firstName: 'First Name',
      lastName: 'Last Name',
      organization: 'Organization',
      jobRole: 'Job Role',
      phone: 'Phone',
      mobilePhone: 'Mobile Phone',
      countryRegion: 'Country / Region',
      address: 'Address',
      city: 'City',
      state: 'State',
      postCode: 'Post code / Zip code',
      department: 'Department',
      productCategory: 'Product categories of interest',
      fields: 'Fields of interest',
      emailSubscription:
        "I agree that Shimadzu will use personal data provided by me to communicate (including by email and SMS) with me to provide information about Shimadzu's and/or its subsidiaries' products and/or services."
    },
    jobRoles: {
      'R&D': 'R&D',
      Manufacturing: 'Manufacturing',
      Sales: 'Sales',
      Marketing: 'Marketing',
      Other: 'Other'
    },
    thanks: {
      title: 'Thank You',
      message: 'Your information has been updated.'
    },
    /** リンク専用画面 */
    SpecialAccess: {
      paramError: 'Unable to process because the URL parameter did not exist.',
      paramFormatError:
        'Unable to process because the URL parameter is incorrect.',
      description1:
        'After a while, you will be automatically redirected to the content.',
      description2:
        'If you are not redirected automatically, please click on the link below.'
    },
    /** サイト内検索form */
    searchForm: {
      SearchButton: 'Search',
      ResetButton: 'Reset'
    },
    /** Webform */
    LoginiconWebform: {
      title: 'Already Registered',
      description: 'If you already have an account, please log in.',
      caution:
        '* For customers who have not registered the below information in your account, you will need to enter it on this page.'
    },
    /** Login */
    LoginModal: {
      title1: 'Sign in to continue',
      title2: 'or',
      title3: 'create an account',
      cookieDisabled1: 'Cookies are disabled.',
      cookieDisabled2: 'You must enable cookies in your browser to use MYPAGE.',
      cookieDisabled3: 'Please enable cookie settings and try again.',
      staySignedIn: 'Stay signed in',
      forgotPassword: 'Forgot your password?',
      troubleLink: '/an/service-support/faq/web/cannot-login.html',
      trouble: 'Trouble signing in?'
    },
    MypageIcon: {
      text: 'My SHIMADZU'
    },
    passwordRemind: {
      title: 'Forgotten Password?',
      text: 'Please enter your login email address to see options for regaining access to your account.',
      label: 'Email Address *',
      ctaButton: 'Continue',
      nextModelText1: 'An e-mail has been to the following e-mail address.',
      nextModelText2: 'Access the URL and change password.',
      nextModelText3:
        'The URL is valid for 24 hours, so please do it within 24 hours.',
      nextModallabel: 'Email Address'
    },
    RegisterIcon: {
      text: 'Register'
    },
    /** RegisterAdditionalModal */
    RegisterAdditionalModal: {
      title1: 'Complete your',
      title2: 'account set-up',
      text1: 'Thanks for creating an account.',
      text2: 'Please use the Documents download.',
      button: 'Documents download'
    },
    /** RenewalUserModal */
    RenewalUserModal: {
      text1:
        'Along with the website redesign, the membership management system has also been redesigned.',
      text2:
        'The new system stores your first and last name separately, so please check that your data is correct.',
      button: 'Go to MYPAGE'
    },
    /** AuthCodeModal */
    AuthCodeModal: {
      title: 'Enter The Code',
      text: 'Enter the code sent to your email.',
      label: 'Code *',
      button: 'Submit'
    },
    /** ReLoginModal */
    ReLoginModal: {
      title: 'Re-Authentication',
      text: 'For security reasons, please log in again to confirm your identity',
      label: 'Password *',
      button: 'Confirm'
    },
    LoginCheckPage: {
      title: 'Sign in to continue',
      description: 'You must be signed in to view this page.'
    },
    ErrorModal: {
      errorMessage: 'system error.',
      finalizeRegistration: 'Sign-in has failed. Please sign-in again.'
    }
  },
  'zh-hant': {
    /** ユーザ項目 */
    User: {
      email: '電子郵件',
      password: '密碼',
      firstName: '名字',
      lastName: '姓氏',
      organization: '公司/學校名稱',
      jobRole: '職位',
      phone: '電話號碼',
      mobilePhone: '行動電話號碼',
      countryRegion: '國家/地區',
      address: '公司地址',
      city: '城市',
      state: 'State',
      postCode: '郵遞區號',
      department: '部門/科系',
      productCategory: '感興趣的產品類別',
      fields: '感興趣的領域',
      emailSubscription: '訂閱接收電子郵件快報'
    },
    jobRoles: {
      'R&D': '研發',
      Manufacturing: '製造業',
      Sales: '業務',
      Marketing: '行銷',
      Other: '其他'
    },
    thanks: {
      title: '感謝您',
      message: '您的資料已更新。'
    },
    /** リンク専用画面 */
    SpecialAccess: {
      paramError: '執行錯誤：您所搜尋的網址 (URL) 不存在。',
      paramFormatError: '執行錯誤：您所搜尋的網址 (URL) 不正確。',
      description1: '請稍候，您將會被轉跳至指定頁面。',
      description2: '如果您沒有自動轉跳至指定頁面，請點擊下方連結。'
    },
    /** サイト内検索form */
    searchForm: {
      SearchButton: '搜尋',
      ResetButton: '清除'
    },
    /** Webform */
    LoginiconWebform: {
      title: '已有註冊帳號',
      description: '如您已有註冊過帳號，請直接登入。',
      caution:
        '* 如您尚未在您的帳戶中填寫以下訊息，麻煩在此頁面上輸入完整訊息。'
    },
    /** Login */
    LoginModal: {
      title1: '登入以繼續',
      title2: '或',
      title3: '註冊帳號',
      cookieDisabled1: 'Cookie 已禁用。',
      cookieDisabled2: '您必須在瀏覽器中啟用 cookie 才能使用 MYPAGE。',
      cookieDisabled3:
        '請輸入您的登錄電子信箱以查看重新獲得帳戶訪問權限的選項。',
      staySignedIn: '請保持登入狀態。',
      forgotPassword: '忘記密碼？',
      troubleLink: '/an/service-support/faq/web/cannot-login.html',
      trouble: '無法登入？'
    },
    MypageIcon: {
      text: '我的頁面'
    },
    passwordRemind: {
      title: '忘記密碼？',
      text: '請輸入您的登錄電子信箱以查看重新獲得帳戶訪問權限的選項。',
      label: '電子郵件 *',
      ctaButton: '繼續',
      nextModelText1: '通知郵件已發送至以下電子信箱。',
      nextModelText2: '點擊網址並更改密碼。',
      nextModelText3: '網址期限為24小時，請於24小時內完成。',
      nextModallabel: '電子郵件'
    },
    RegisterIcon: {
      text: '註冊'
    },
    /** RegisterAdditionalModal */
    RegisterAdditionalModal: {
      title1: '完成您的',
      title2: '帳戶設定',
      text1: '感謝您設立會員帳號。',
      text2: '請使用資料下載功能。',
      button: '資料下載'
    },
    /** RenewalUserModal */
    RenewalUserModal: {
      text1: '隨著網站更新，會員管理系統也進行了更新作業。',
      text2: '新系統分別存儲您的名字和姓氏，因此請檢查您的數據是否正確。',
      button: '前往MYPAGE'
    },
    /** AuthCodeModal */
    AuthCodeModal: {
      title: '認證碼',
      text: '請輸入授權碼。',
      label: '授權碼 *',
      button: '提交'
    },
    /** ReLoginModal */
    ReLoginModal: {
      title: '再次認證',
      text: '再次認證用訊息',
      label: '密碼 *',
      button: '確認'
    },
    ErrorModal: {
      errorMessage: 'system error.',
      finalizeRegistration: '登入失敗。請再試一次。'
    }
  },
  ja: {
    /** ユーザ項目 */
    User: {
      email: 'メールアドレス',
      password: 'パスワード',
      firstName: '名',
      lastName: '姓',
      organization: 'ご勤務先',
      jobRole: '職種',
      phone: '電話番号',
      mobilePhone: '携帯電話番号',
      countryRegion: '国 / エリア',
      address: '勤務先住所',
      city: '市',
      state: '都道府県',
      postCode: '郵便番号',
      department: '所属部署',
      productCategory: '興味のある製品',
      fields: '興味のある分野',
      emailSubscription:
        '私は、島津製作所および/またはその子会社の製品および/またはサービスに関する情報を提供するために、島津製作所が私との通信 (電子メールおよび SMS を含む) のために私から提供された個人データを使用することに同意します。'
    },
    jobRoles: {
      'R&D': '研究開発',
      Manufacturing: '製造',
      Sales: '営業',
      Marketing: 'マーケティング',
      Other: 'その他'
    },
    thanks: {
      title: 'ありがとうございました。',
      message: 'あなたの情報が更新されました。'
    },
    /** リンク専用画面 */
    SpecialAccess: {
      paramError: 'URL パラメータが存在しないため、処理できません。',
      paramFormatError: 'URL パラメータが正しくないため、処理できません。',
      description1: '自動的にコンテンツにリダイレクトされます。',
      description2:
        '自動的にリダイレクトされない場合は、以下のリンクをクリックしてください。'
    },
    /** サイト内検索form */
    searchForm: {
      SearchButton: '検索',
      ResetButton: 'リセット'
    },
    /** Webform */
    LoginiconWebform: {
      title: '',
      description:
        '既に会員制サービスMy SHIMADZU for Analyticalのアカウントをお持ちの場合',
      caution:
        '※ログインいただくと登録頂ている会員情報が自動的に反映されます。追加で入力が必要な項目もございます。'
    },
    RegisterIcon: {
      text: '登録'
    },
    /** RegisterAdditionalModal */
    RegisterAdditionalModal: {
      title1: '完了',
      title2: 'アカウント設定',
      text1: 'アカウントを作成していただきありがとうございます',
      text2: 'ダウンロードをご利用ください',
      button: 'ダウンロード'
    },
    /** RenewalUserModal */
    RenewalUserModal: {
      text1: 'サイトリニューアルに伴い、会員管理システムもリニューアル',
      text2:
        '新しいシステムでは姓と名が別々に保存されるため、データが正しいことを確認してください',
      button: 'マイページへ行く'
    },
    /** AuthCodeModal */
    AuthCodeModal: {
      title: 'コードを入力します',
      text: 'メールに送信されたコードを入力してください',
      label: 'コード *',
      button: '送信'
    },
    /** ReLoginModal */
    ReLoginModal: {
      title: '再認証',
      text: 'セキュリティ上の理由から、再度ログインして本人確認を行ってください',
      label: 'パスワード *',
      button: '確認'
    },
    LoginCheckPage: {
      title: 'サインインして続行',
      description: 'このページを表示するには、サインインする必要があります。'
    },
    ErrorModal: {
      errorMessage: 'システムエラー',
      finalizeRegistration:
        'サインインに失敗しました。再度サインインしてください。'
    }
  },
  es: {
    /** ユーザ項目 */
    User: {
      email: 'Dirección de correo electrónico',
      password: 'Contraseña',
      firstName: 'Nombre',
      lastName: 'Apellido',
      organization: 'Organización',
      jobRole: 'Puesto de trabajo',
      phone: 'Teléfono',
      mobilePhone: 'Teléfono móvil',
      countryRegion: 'País / Región',
      address: 'Dirección',
      city: 'Ciudad',
      state: 'Estado',
      postCode: 'Código postal / Código postal',
      department: 'Department',
      productCategory: 'Categorías de productos de interés',
      fields: 'Campos de interés',
      emailSubscription:
        'Acepto que Shimadzu utilice los datos personales proporcionados por mí para comunicarse (incluso por correo electrónico y SMS) conmigo para proporcionar información sobre los productos y / o servicios de Shimadzu y / o sus subsidiarias.'
    },
    jobRoles: {
      'R&D': 'I+D',
      Manufacturing: 'Fabricación',
      Sales: 'Ventas',
      Marketing: 'Marketing',
      Other: 'Otro'
    },
    thanks: {
      title: 'Gracias',
      message: 'Su información ha sido actualizada.'
    },
    /** リンク専用画面 */
    SpecialAccess: {
      paramError: 'No se pudo procesar porque el parámetro de URL no existía.',
      paramFormatError:
        'No se puede procesar porque el parámetro de URL es incorrecto.',
      description1:
        'Después de un tiempo, será redirigido automáticamente al contenido.',
      description2:
        'Si no es redirigido automáticamente, haga clic en el siguiente enlace.'
    },
    /** サイト内検索form */
    searchForm: {
      SearchButton: 'Búsqueda',
      ResetButton: 'Restablecer'
    },
    /** Webform */
    LoginiconWebform: {
      title: 'Ya registrado',
      description: 'Si ya tiene una cuenta, inicie sesión.',
      caution:
        '* Para los clientes que no han registrado la siguiente información en su cuenta, deberá ingresarla en esta página.'
    },
    /** Login */
    LoginModal: {
      title1: 'Inicia sesión para continuar',
      title2: 'o',
      title3: 'Crear una cuenta',
      cookieDisabled1: 'Las cookies están desactivadas.',
      cookieDisabled2:
        'Debe habilitar las cookies en su navegador para utilizar MYPAGE.',
      cookieDisabled3:
        'Habilite la configuración de cookies e inténtelo de nuevo.',
      staySignedIn: 'Mantener la sesión iniciada',
      forgotPassword: '¿Olvidó su contraseña?',
      troubleLink: '/service-support/faq/web/cannot-login.html',
      trouble: '¿Tiene problemas para iniciar sesión?'
    },
    MypageIcon: {
      text: 'My SHIMADZU'
    },
    passwordRemind: {
      title: '¿Olvidó su contraseña?',
      text: 'Ingrese su dirección de correo electrónico de inicio de sesión para ver las opciones para recuperar el acceso a su cuenta.',
      label: 'Dirección de correo electrónico *',
      ctaButton: 'Continuar',
      nextModelText1:
        'Se ha enviado un correo electrónico a la siguiente dirección de correo electrónico.',
      nextModelText2: 'Acceda a la URL y cambie la contraseña.',
      nextModelText3:
        'La URL es válida durante 24 horas, así que hágalo dentro de las 24 horas.',
      nextModallabel: 'Dirección de correo electrónico'
    },
    RegisterIcon: {
      text: 'Registrarse'
    },
    /** RegisterAdditionalModal */
    RegisterAdditionalModal: {
      title1: 'Complete su',
      title2: 'Configuración de la cuenta',
      text1: 'Gracias por crear una cuenta.',
      text2: 'Utilice la descarga de documentos.',
      button: 'Descarga de documentos'
    },
    /** RenewalUserModal */
    RenewalUserModal: {
      text1:
        'Junto con el rediseño del sitio web, también se ha rediseñado el sistema de gestión de miembros.',
      text2:
        'El nuevo sistema almacena su nombre y apellido por separado, así que compruebe que sus datos son correctos.',
      button: 'Ir a MIPÁGINA'
    },
    /** AuthCodeModal */
    AuthCodeModal: {
      title: 'Introduzca el código',
      text: 'Introduce el código enviado a tu correo electrónico.',
      label: 'Código*',
      button: 'Enviar'
    },
    /** ReLoginModal */
    ReLoginModal: {
      title: 'Reautenticación',
      text: 'Por razones de seguridad, vuelva a iniciar sesión para confirmar su identidad',
      label: 'Contraseña *',
      button: 'Confirmar'
    },
    LoginCheckPage: {
      title: 'Inicia sesión para continuar',
      description: 'Debe haber iniciado sesión para ver esta página.'
    },
    ErrorModal: {
      errorMessage: 'Error del sistema.',
      finalizeRegistration:
        'El inicio de sesión ha fallado. Inicie sesión de nuevo.'
    }
  },
  'pt-br': {
    /** ユーザ項目 */
    User: {
      email: 'Endereço de email',
      password: 'Senha',
      firstName: 'Primeiro nome',
      lastName: 'Sobrenome',
      organization: 'Organização',
      jobRole: 'Cargo',
      phone: 'Telefone',
      mobilePhone: 'Celular',
      countryRegion: 'País / Região',
      address: 'Endereço',
      city: 'Cidade',
      state: 'Estado',
      postCode: 'CEP / Código postal',
      department: 'Departamento',
      productCategory: 'Categorias de produtos de interesse',
      fields: 'Campos de interesse',
      emailSubscription:
        'Concordo que a Shimadzu usará os dados pessoais fornecidos por mim para se comunicar (inclusive por e-mail e SMS) comigo para fornecer informações sobre os produtos e/ou serviços da Shimadzu e/ou de suas subsidiárias.'
    },
    jobRoles: {
      'R&D': 'P&D',
      Manufacturing: 'Manufatura',
      Sales: 'Vendas',
      Marketing: 'Marketing',
      Other: 'Outro'
    },
    thanks: {
      title: 'Obrigado',
      message: 'Suas informações foram atualizadas.'
    },
    /** リンク専用画面 */
    SpecialAccess: {
      paramError:
        'Não foi possível processar porque o parâmetro de URL não existe.',
      paramFormatError:
        'Não foi possível processar porque o parâmetro de URL está incorreto.',
      description1:
        'Depois de um tempo, você será redirecionado automaticamente para o conteúdo.',
      description2:
        'Se você não for redirecionado automaticamente, clique no link abaixo.'
    },
    /** サイト内検索form */
    searchForm: {
      SearchButton: 'Procurar',
      ResetButton: 'Restablecer'
    },
    /** Webform */
    LoginiconWebform: {
      title: 'Já tem uma conta?',
      description: 'Se você já possui uma conta, por favor, faça o login.',
      caution:
        '* Para os clientes que não registraram as informações abaixo em sua conta, é necessário inserir nesta página.'
    },
    /** Login */
    LoginModal: {
      title1: 'Faça login para continuar',
      title2: 'ou',
      title3: 'Crie a sua conta aqui',
      cookieDisabled1: 'Os cookies estão desativados.',
      cookieDisabled2:
        'Você deve ativar os cookies em seu navegador para usar MYPAGE.',
      cookieDisabled3: 'Ative as configurações de cookies e tente novamente.',
      staySignedIn: 'Permanecer conectado',
      forgotPassword: 'Esqueceu sua senha?',
      troubleLink: '/service-support/faq/web/cannot-login.html',
      trouble: 'Problemas para fazer login?'
    },
    MypageIcon: {
      text: 'My SHIMADZU'
    },
    passwordRemind: {
      title: 'Esqueceu a Palavra-chave?',
      text: 'Digite seu endereço de e-mail para verificar as opções de recuperação da sua conta.',
      label: 'Alterar o endereço de e-mail *',
      ctaButton: 'Continuar',
      nextModelText1: 'O e-mail foi enviado para o endereço.',
      nextModelText2: 'Acesse a URL e altere a senha.',
      nextModelText3:
        'A URL é válida por 24 horas, acesse durante este período.',
      nextModallabel: 'Alterar o endereço de e-mail'
    },
    RegisterIcon: {
      text: 'Inscreva-se'
    },
    /** RegisterAdditionalModal */
    RegisterAdditionalModal: {
      title1: 'Complete seu',
      title2: 'Configuração da conta',
      text1: 'Obrigado por criar uma conta.',
      text2: 'Por favor, use o download de documentos.',
      button: 'Baixar documentos'
    },
    /** RenewalUserModal */
    RenewalUserModal: {
      text1:
        'Junto com o novo layout do site, o sistema de gerenciamento de membros também foi readequado.',
      text2:
        'O novo sistema armazena seu nome e sobrenome separadamente, portanto, verifique se seus dados estão corretos.',
      button: 'Ir para MYPAGE'
    },
    /** AuthCodeModal */
    AuthCodeModal: {
      title: 'Digite o código',
      text: 'Digite o código enviado para o seu e-mail.',
      label: 'Código *',
      button: 'Enviar'
    },
    /** ReLoginModal */
    ReLoginModal: {
      title: 'Reautenticação',
      text: 'Por motivos de segurança, faça login novamente para confirmar sua identidade',
      label: 'Senha *',
      button: 'Confirmar'
    },
    LoginCheckPage: {
      title: 'Faça login para continuar',
      description: 'Você deve estar logado para visualizar esta página.'
    },
    ErrorModal: {
      errorMessage: 'Erro no sistema.',
      finalizeRegistration: 'O login falhou. Faça login novamente.'
    }
  }
}

export default Translate([
  MemberShip,
  DownloadMessages,
  ChangeMembership,
  Mypage,
  Register,
  Login,
  cardLanguage
])
